angular.module('flipto.accountv1.SharedFeatures')
.constant('incentiveTags', {
    "guest": 1,
    "warmLead": 2,
    "contestPrize": 4
});